// extracted by mini-css-extract-plugin
module.exports = {"md":"time_md_7b2VR","ios":"time_ios_2-N7x","message":"time_message_3g1l7","wrapper":"time_wrapper_2g-_u","closed":"time_closed_ALlp_"};